module.exports = __webpack_public_path__ + "img/p78.87c2d855.png";